/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Lib dependencies
import { useTranslation } from 'react-i18next';

// UI lib components
import {
	BackgroundImage,
	Box,
	Flex,
	Image,
	Text,
} from '@mantine/core';

// UI local components
import { LanguageSelect } from '@components/atoms/LanguageSelect';
import { ForgotPassword } from '@features/auth/components/ForgotPassword/ForgotPassword';
import { SignIn } from '@features/auth/components/SignIn';

// Images
import ArecBackground from '@assets/images/arec-background-2.webp';
import InukLogo from '@assets/images/inuk-logo.svg';

// Styles
import classes from './login.module.css';

// Localstorage
import { useLocalStorage } from '@hooks/useLocalStorage';

// Hooks
import useStore from '@store/index';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
const Auth = () => {
	/* ********************************** HOOKS ********************************* */
	const { i18n, t } = useTranslation();
	const [lng, setLng] = useLocalStorage('lng', 'fr');
	const { authForm, setAuthForm } = useStore();

	/* ******************************** HELPERS ******************************* */

	const handlenavigate = (_target: string) => {
		setAuthForm(_target);
	};

	function NavigateComponents() {
		if (authForm === 'signin')
			return <SignIn handlenavigate={handlenavigate} />;
		if (authForm === 'reset')
			return (
				<ForgotPassword handlenavigate={handlenavigate} />
			);
	}
	/* ******************************** RENDERING ******************************* */
	return (
		<Box className={classes.layout}>
			<Box className={classes.header}>
				<Box className={classes.containerLogo}>
					<Image
						className={classes.logo}
						src={InukLogo}
						fit="contain"
					/>
				</Box>
				<Box className={classes.containerLanguage}>
					<LanguageSelect
						defaultValue={lng}
						onChange={(data: string) => {
							i18n.changeLanguage(data);
							setLng(data);
						}}
					/>
				</Box>
			</Box>
			<Box className={classes.content}>
				<Box className={classes.wrapper}>
					<Box className={classes.containerLeft}>
						<NavigateComponents />
					</Box>
					<Box className={classes.containerRight}>
						<BackgroundImage
							h={'80%'}
							w={'80%'}
							src={ArecBackground}
							radius={'xl'}
						>
							<Flex
								direction={'column'}
								flex={1}
								h={'100%'}
								pl={'25px'}
								pr={'25px'}
								pt={'25px'}
								pb={'80px'}
								justify={'space-between'}
							>
								<Flex justify={'end'}>
									<Image
										src={
											'https://res.cloudinary.com/inuk/image/upload/v1757070408/LOGO-AREC-2019_gmmvnx.png'
										}
										h={'100px'}
										w={'100px'}
									/>
								</Flex>
								<Flex direction={'column'}>
									<Text
										className={classes.backgroundTitle}
									>
										{t('arec.title1')}
									</Text>
									<Text
										className={classes.backgroundTitle}
									>
										{t('arec.title2')}
									</Text>
									<Text
										className={
											classes.backgroundDescription
										}
									>
										{t('arec.description1')}
									</Text>
									<Text
										className={
											classes.backgroundDescription
										}
									>
										{t('arec.description2')}
									</Text>
								</Flex>
							</Flex>
						</BackgroundImage>
					</Box>
				</Box>
			</Box>
			<Box className={classes.footer} />
		</Box>
	);
};

export default Auth;
